export const EMPTY_PROBLEM_CARD = {
  illust: '/illust/empty-problem.png',
  title: '아직 등록된 시민문제가 없어요.',
  lines: ['일상에서 겪는 불편함이나', '해결이 필요한 문제를 알려주세요.'],
  actionText: '문제 등록하러 가기',
  actionTo: '/problems/new',
}

export const EMPTY_ORG_CARD = {
  illust: '/illust/empty-org.png',
  title: '아직 등록된 기업이 없어요.',
  lines: ['우리 동네 문제 해결에', '함께할 기업을 기다리고 있어요.'],
  actionText: '기업 등록하러 가기',
  actionTo: '/orgs/new',
}
